var sentenceCase = require('sentence-case')

/**
 * Path case a string.
 *
 * @param  {String} string
 * @param  {String} [locale]
 * @return {String}
 */
module.exports = function (string, locale) {
  return sentenceCase(string, locale, '/')
}



//////////////////
// WEBPACK FOOTER
// ./~/path-case/path-case.js
// module id = 1170
// module chunks = 4